module.exports = __webpack_public_path__ + "img/RB-Salzburg.d7376f6e.png";